<template>
  <div class="oh-page">
    <div class="oh-inner">
      <div class="oh-top">
        <div class="oh-account">账号: {{ account }}</div>
        <div class="oh-top-actions">
          <button type="button" class="oh-pill oh-pill--ghost" @click="showRules = true">系统公告</button>
          <button type="button" class="oh-pill oh-pill--blue" @click="toast('请联系管理员获取客服方式')">联系客服</button>
        </div>
      </div>

      <div class="oh-balance">
        <div class="oh-balance-label">余额：</div>
        <div class="oh-balance-num">{{ formatMoney(balance) }}</div>
        <div class="oh-balance-sub">
          总余额 {{ formatMoney(balance) }}
          &nbsp;&nbsp;交易中 {{ formatMoney(trading) }}
          &nbsp;&nbsp;冻结中 {{ formatMoney(frozen) }}
        </div>
      </div>

      <div class="oh-comm-bar">
        <span>所有返佣 {{ allCommission }}</span>
        <span>我的返佣 {{ myCommission }}</span>
      </div>

      <div class="oh-actions">
        <button type="button" class="oh-action" @click="openRecharge">
          <div class="oh-action-icon">充</div>
          <div class="oh-action-label">充值</div>
        </button>
        <button type="button" class="oh-action" @click="openTransfer">
          <div class="oh-action-icon">转</div>
          <div class="oh-action-label">转账</div>
        </button>
        <button type="button" class="oh-action" @click="showCollect = true">
          <div class="oh-action-icon">收</div>
          <div class="oh-action-label">收款管理</div>
        </button>
        <button type="button" class="oh-action" @click="openEmpty">
          <div class="oh-action-icon">空</div>
          <div class="oh-action-label">申请空放</div>
        </button>
      </div>

      <div class="oh-tabs">
        <button
          v-for="t in tabs"
          :key="t.key"
          type="button"
          class="oh-tab"
          :class="{ 'oh-tab--active': activeTab === t.key }"
          @click="activeTab = t.key"
        >{{ t.label }}</button>
      </div>

      <div class="oh-list">
        <div v-for="order in filteredOrders" :key="order.id" class="oh-order">
          <div class="oh-order-top">
            <div>
              <div class="oh-muted">订单号：</div>
              <div class="oh-strong">{{ order.id }}</div>
            </div>
            <div class="oh-order-status">
              <div class="oh-muted">状态：</div>
              <div class="oh-status">{{ order.status }}</div>
            </div>
          </div>

          <div class="oh-order-mid">
            <div><span class="oh-muted">收款金额：</span><span class="oh-amt">{{ order.amount }}</span></div>
            <div class="oh-right"><span class="oh-muted">返佣金额：</span><span class="oh-comm">{{ order.commissionDisplay }}</span></div>
            <div><span class="oh-muted">创建时间：</span><span class="oh-strong">{{ order.createdAt }}</span></div>
            <div></div>
            <div><span class="oh-muted">收款类型：</span><span class="oh-strong">{{ order.payType }}</span></div>
            <div></div>
          </div>

          <div class="oh-order-actions">
            <button
              v-if="order.canTake && order.status === '等待抢单'"
              type="button"
              class="oh-btn oh-btn--take"
              @click="takeOrder(order)"
            >抢单</button>
            <button v-else type="button" class="oh-btn oh-btn--disabled" disabled>不可抢</button>
          </div>
        </div>
        <div v-if="!filteredOrders.length" class="oh-empty">暂无订单</div>
      </div>
    </div>

    <!-- 规则公告 -->
    <div v-if="showRules" class="oh-mask" @click.self="showRules = false">
      <div class="oh-modal">
        <div class="oh-modal-head">规则公告</div>
        <div class="oh-modal-body">
          <p>本平台纯BC菠菜料，绝无假料，本产品对接BC平台充值订单分配。</p>
          <p>1.本平台支持：【数字RMB钱包编码】【支付宝账号】【支付宝官方收款码】【支付宝UID】【微信收款码】【银行卡卡号】</p>
          <p>2.本平台有法律保障7天，若料号被冻结，冻结金额1000RMB以下自行承担，超过10000RMB以上平台承担一半责任（被冻账号报警报案并提供相关证明，审核通过后理赔）。</p>
          <p>3.禁止恶意抢单、收款后不确认订单等行为，一经核实永久冻结账号并追责。</p>
          <p>4.系统仅支持USDT充值，到账自动到账；个人申请退款收取2%系统手续费。</p>
        </div>
        <div class="oh-modal-foot">
          <button type="button" class="oh-modal-btn oh-modal-btn--yellow" @click="showRules = false">关闭</button>
        </div>
      </div>
    </div>

    <!-- 充值 -->
    <div v-if="showRecharge" class="oh-mask" @click.self="showRecharge = false">
      <div class="oh-modal">
        <div class="oh-modal-head">充值</div>
        <div class="oh-modal-body">
          <input v-model="rechargeAmount" class="oh-modal-input" type="number" min="200" placeholder="输入金额" />
          <p class="oh-hint">最低充值 50。点击“去支付”将跳转到钱包页面。</p>
        </div>
        <div class="oh-modal-foot oh-modal-foot--row">
          <button type="button" class="oh-modal-btn oh-modal-btn--gray" @click="showRecharge = false">取消</button>
          <button type="button" class="oh-modal-btn oh-modal-btn--yellow" @click="goPay">去支付</button>
        </div>
      </div>
    </div>

    <!-- 转账 -->
    <div v-if="showTransfer" class="oh-mask" @click.self="showTransfer = false">
      <div class="oh-modal">
        <div class="oh-modal-head">转账</div>
        <div class="oh-modal-body">
          <input v-model="transferTarget" class="oh-modal-input" type="text" placeholder="对方账号" />
          <input v-model="transferAmount" class="oh-modal-input" type="number" min="1" placeholder="转账金额" style="margin-top:12px" />
          <p class="oh-hint">请确认对方账号无误后再提交。</p>
        </div>
        <div class="oh-modal-foot oh-modal-foot--row">
          <button type="button" class="oh-modal-btn oh-modal-btn--gray" @click="showTransfer = false">取消</button>
          <button type="button" class="oh-modal-btn oh-modal-btn--yellow" @click="doTransfer">确认</button>
        </div>
      </div>
    </div>

    <!-- 收款管理 -->
    <div v-if="showCollect" class="oh-mask" @click.self="showCollect = false">
      <div class="oh-modal">
        <div class="oh-modal-head">收款管理</div>
        <div class="oh-modal-body">
          <p>请添加并维护你的收款方式：</p>
          <p>支付宝账号 / 支付宝收款码 / 微信收款码 / 银行卡卡号 / 数字RMB钱包编码</p>
          <p class="oh-hint">如需修改请联系客服审核开通。</p>
        </div>
        <div class="oh-modal-foot">
          <button type="button" class="oh-modal-btn oh-modal-btn--yellow" @click="showCollect = false">关闭</button>
        </div>
      </div>
    </div>

    <!-- 申请空放 -->
    <div v-if="showEmpty" class="oh-mask" @click.self="closeEmpty">
      <div class="oh-modal">
        <div class="oh-modal-head">{{ emptyVerified ? '空放验证支付' : '申请空放额度' }}</div>
        <div v-if="!emptyVerified" class="oh-modal-body">
          <input v-model="emptyCode" class="oh-modal-input" type="text" placeholder="请输入管理员给你提供的空放码" />
          <p class="oh-hint">可用额度：100 / 200 / 300 / 500 / 1000 / 2000</p>
        </div>
        <div v-else class="oh-modal-body">
          <div class="oh-empty-quota">空放码额度：{{ formatMoney(emptyQuota) }}</div>
          <div class="oh-empty-amount">{{ emptyPayAmount }} U</div>
          <p class="oh-hint">验证成功，请支付随机金额绑定回款地址</p>
        </div>
        <div class="oh-modal-foot oh-modal-foot--row">
          <button type="button" class="oh-modal-btn oh-modal-btn--gray" @click="closeEmpty">取消</button>
          <button
            v-if="!emptyVerified"
            type="button"
            class="oh-modal-btn oh-modal-btn--yellow"
            @click="verifyEmpty"
          >验证</button>
          <button
            v-else
            type="button"
            class="oh-modal-btn oh-modal-btn--yellow"
            @click="goEmptyPay"
          >去支付</button>
        </div>
      </div>
    </div>

    <!-- 余额不足提示 -->
    <div v-if="showTip" class="oh-mask" @click.self="showTip = false">
      <div class="oh-modal">
        <div class="oh-modal-head">提示</div>
        <div class="oh-modal-body oh-modal-body--center">
          <p>{{ tipText }}</p>
        </div>
        <div class="oh-modal-foot oh-modal-foot--row">
          <button type="button" class="oh-modal-btn oh-modal-btn--gray" @click="showTip = false">关闭</button>
          <button type="button" class="oh-modal-btn oh-modal-btn--yellow" @click="fromTipToRecharge">去充值</button>
        </div>
      </div>
    </div>

    <div v-if="toastMsg" class="oh-toast">{{ toastMsg }}</div>
  </div>
</template>

<script>
import orderData from '../data/orderHallOrders.json';
import { addOrder } from '../util/api';
import { buildReferralQuery, resolveReferralContext } from '../util/deeplink';
import { generateMockHallOrders, HALL_REFRESH_MS } from '../util/orderHallMock';
import { makeOrderNo, pushSelectWallet } from '../util/paymentFlow';

const ACCOUNT_KEY = 'order_auth_account';
const BALANCE_KEY = 'order_auth_balance';

const EMPTY_CODES = {
  R8S9T0: 100,
  N5P6Q7: 200,
  G7H8J9: 300,
  K2L3M4: 500,
  D4E5F6: 1000,
  A1B2C3: 2000,
};

function randomEmptyPayAmount() {
  const n = Math.random();
  const amount = n <= 0 ? 0.000001 : Math.min(n, 0.999999);
  return amount.toFixed(6);
}

export default {
  name: 'OrderHall',
  data() {
    return {
      account: localStorage.getItem(ACCOUNT_KEY) || '未登录',
      balance: Number(localStorage.getItem(BALANCE_KEY) || 0),
      trading: 0,
      frozen: 0,
      allCommission: orderData.allCommission || '44296.24',
      myCommission: orderData.myCommission || '0.00',
      hallOrders: [],
      myTakenOrders: [],
      refreshTimer: null,
      activeTab: 'hall',
      tabs: [
        { key: 'hall', label: '订单大厅' },
        { key: 'pending', label: '待确认' },
        { key: 'trading', label: '交易中' },
        { key: 'paused', label: '暂停中' },
      ],
      showRules: false,
      showRecharge: false,
      showTransfer: false,
      showCollect: false,
      showEmpty: false,
      showTip: false,
      tipText: '余额不足，请先充值',
      rechargeAmount: '',
      transferTarget: '',
      transferAmount: '',
      emptyCode: '',
      emptyVerified: false,
      emptyQuota: 0,
      emptyPayAmount: '',
      toastMsg: '',
      toastTimer: null,
      referralCode: '',
      gameGroupId: '',
      paying: false,
    };
  },
  computed: {
    filteredOrders() {
      if (this.activeTab === 'hall') return this.hallOrders;
      if (this.activeTab === 'pending') {
        return this.myTakenOrders.filter((o) => o.status === '待确认');
      }
      if (this.activeTab === 'trading') {
        return this.myTakenOrders.filter((o) => o.status === '交易中');
      }
      if (this.activeTab === 'paused') {
        return this.myTakenOrders.filter((o) => o.status === '暂停中');
      }
      return this.hallOrders;
    },
  },
  created() {
    const ctx = resolveReferralContext(this.$route);
    this.referralCode = ctx.referralCode;
    this.gameGroupId = ctx.gameGroupId;

    if (!localStorage.getItem(ACCOUNT_KEY)) {
      this.$router.replace({
        path: '/orderAuth',
        query: buildReferralQuery(this.referralCode, this.gameGroupId),
      });
      return;
    }
    this.refreshHallOrders();
    this.refreshTimer = setInterval(() => this.refreshHallOrders(), HALL_REFRESH_MS);
  },
  beforeUnmount() {
    if (this.refreshTimer) clearInterval(this.refreshTimer);
  },
  methods: {
    refreshHallOrders() {
      this.hallOrders = generateMockHallOrders(8);
    },
    formatMoney(n) {
      const num = Number(n) || 0;
      return num.toFixed(2);
    },
    toast(msg) {
      this.toastMsg = msg;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toastMsg = '';
      }, 2000);
    },
    openRecharge() {
      this.rechargeAmount = '';
      this.showRecharge = true;
    },
    openTransfer() {
      if (this.balance <= 0) {
        this.tipText = '余额不足，请先充值';
        this.showTip = true;
        return;
      }
      this.transferTarget = '';
      this.transferAmount = '';
      this.showTransfer = true;
    },
    openEmpty() {
      this.emptyCode = '';
      this.emptyVerified = false;
      this.emptyQuota = 0;
      this.emptyPayAmount = '';
      this.showEmpty = true;
    },
    closeEmpty() {
      this.showEmpty = false;
      this.emptyVerified = false;
      this.emptyQuota = 0;
      this.emptyPayAmount = '';
    },
    fromTipToRecharge() {
      this.showTip = false;
      this.openRecharge();
    },
    async createHallOrder({ title, price, inputGT }) {
      if (!this.referralCode) {
        this.toast('缺少推广码，请从授权链接重新进入');
        return false;
      }
      if (this.paying) return false;
      this.paying = true;
      const data = {
        title,
        price,
        inputNumber: 1,
        inputGT: inputGT || this.account,
        orderNo: makeOrderNo(),
        referral_code: this.referralCode,
      };
      try {
        await addOrder(data);
        pushSelectWallet(this.$router, data, this.gameGroupId);
        return true;
      } catch (e) {
        console.error(e);
        this.toast('下单失败，请稍后重试');
        return false;
      } finally {
        this.paying = false;
      }
    },
    async goPay() {
      const amount = Number(this.rechargeAmount);
      if (!amount || amount < 50) {
        this.toast('最低充值 50');
        return;
      }
      const ok = await this.createHallOrder({
        title: '订单大厅充值',
        price: amount,
        inputGT: this.account,
      });
      if (ok) this.showRecharge = false;
    },
    doTransfer() {
      const amount = Number(this.transferAmount);
      const target = this.transferTarget.trim();
      if (!target) {
        this.toast('请输入对方账号');
        return;
      }
      if (!amount || amount <= 0) {
        this.toast('请输入转账金额');
        return;
      }
      if (amount > this.balance) {
        this.showTransfer = false;
        this.tipText = '余额不足，请先充值';
        this.showTip = true;
        return;
      }
      this.balance = Number((this.balance - amount).toFixed(2));
      localStorage.setItem(BALANCE_KEY, String(this.balance));
      this.showTransfer = false;
      this.toast('转账提交成功');
    },
    verifyEmpty() {
      const code = this.emptyCode.trim().toUpperCase();
      const quota = EMPTY_CODES[code];
      if (!quota) {
        this.toast('空放码无效，请重新输入');
        return;
      }
      this.emptyCode = code;
      this.emptyQuota = quota;
      this.emptyPayAmount = randomEmptyPayAmount();
      this.emptyVerified = true;
    },
    async goEmptyPay() {
      const amount = Number(this.emptyPayAmount);
      if (!amount || amount <= 0) {
        this.toast('验证金额异常，请重新验证');
        return;
      }
      const ok = await this.createHallOrder({
        title: `订单大厅空放验证-${this.emptyCode}`,
        price: amount,
        inputGT: `${this.account} / 空放码${this.emptyCode} / 额度${this.emptyQuota}`,
      });
      if (ok) this.closeEmpty();
    },
    takeOrder(order) {
      const need = Number(order.amount) || 0;
      if (this.balance < need) {
        this.tipText = '余额不足，请先充值';
        this.showTip = true;
        return;
      }
      const taken = { ...order, status: '交易中', canTake: false };
      this.myTakenOrders.unshift(taken);
      this.hallOrders = this.hallOrders.filter((o) => o.id !== order.id);
      this.trading = Number((this.trading + need).toFixed(2));
      this.toast('抢单成功');
    },
  },
};
</script>

<style scoped>
.oh-page {
  min-height: 100vh;
  background: #ececec;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  color: #111;
}

.oh-inner {
  max-width: 480px;
  margin: 0 auto;
  padding: 14px 12px 40px;
  background: #f5f5f5;
  min-height: 100vh;
  box-sizing: border-box;
}

.oh-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.oh-account {
  font-size: 18px;
  font-weight: 800;
  white-space: nowrap;
}

.oh-top-actions {
  display: flex;
  gap: 8px;
}

.oh-pill {
  height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
}

.oh-pill--ghost {
  background: #fff;
  border-color: #d5d5d5;
  color: #333;
}

.oh-pill--blue {
  background: #3b82f6;
  color: #fff;
  border-color: #3b82f6;
}

.oh-balance {
  background: #2a2a2a;
  border-radius: 14px;
  padding: 16px 16px 14px;
  color: #fff;
}

.oh-balance-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
}

.oh-balance-num {
  font-size: 42px;
  font-weight: 900;
  color: #ffcc00;
  line-height: 1.1;
  letter-spacing: 0.5px;
}

.oh-balance-sub {
  margin-top: 10px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.72);
  font-weight: 600;
}

.oh-comm-bar {
  margin-top: 10px;
  background: #f3e7c7;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  font-weight: 800;
  font-size: 14px;
  color: #222;
}

.oh-actions {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.oh-action {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  padding: 12px 4px 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.oh-action-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #111;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 16px;
  color: #111;
  background: #fff8d6;
}

.oh-action-label {
  font-size: 12px;
  font-weight: 800;
  color: #222;
}

.oh-tabs {
  margin-top: 16px;
  display: flex;
  gap: 18px;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 2px;
}

.oh-tab {
  border: 0;
  background: transparent;
  padding: 10px 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #666;
  cursor: pointer;
  position: relative;
}

.oh-tab--active {
  color: #111;
  font-weight: 900;
}

.oh-tab--active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: #ffcc00;
  border-radius: 2px;
}

.oh-list {
  margin-top: 10px;
}

.oh-order {
  background: #fff;
  border-radius: 12px;
  padding: 14px 14px 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03);
}

.oh-order-top {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.oh-order-status {
  text-align: right;
}

.oh-muted {
  color: #8a8a8a;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 2px;
}

.oh-strong {
  font-weight: 900;
  font-size: 14px;
  color: #111;
}

.oh-status {
  font-weight: 800;
  color: #777;
  font-size: 14px;
}

.oh-order-mid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 10px;
  font-size: 13px;
  margin-bottom: 12px;
}

.oh-right {
  text-align: right;
}

.oh-amt {
  color: #e53935;
  font-weight: 900;
  font-size: 16px;
}

.oh-comm {
  color: #f0a000;
  font-weight: 900;
  font-size: 16px;
}

.oh-order-actions {
  display: flex;
  justify-content: flex-end;
}

.oh-btn {
  min-width: 86px;
  height: 36px;
  border: 0;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
  padding: 0 16px;
}

.oh-btn--take {
  background: #ffcc00;
  color: #111;
}

.oh-btn--disabled {
  background: #d8d8d8;
  color: #fff;
  cursor: not-allowed;
}

.oh-empty {
  text-align: center;
  color: #999;
  padding: 40px 0;
  font-weight: 700;
}

.oh-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1000;
}

.oh-modal {
  width: min(420px, 94vw);
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.28);
}

.oh-modal-head {
  background: #ffcc00;
  text-align: center;
  font-size: 22px;
  font-weight: 900;
  padding: 14px 12px;
  color: #111;
}

.oh-modal-body {
  padding: 18px 18px 8px;
  font-size: 14px;
  line-height: 1.7;
  font-weight: 600;
  color: #222;
}

.oh-modal-body--center {
  text-align: center;
  padding: 28px 18px 18px;
  font-size: 16px;
}

.oh-modal-body p {
  margin: 0 0 10px;
}

.oh-modal-input {
  width: 100%;
  height: 46px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0 14px;
  font-size: 15px;
  outline: none;
}

.oh-hint {
  margin: 10px 0 0 !important;
  color: #999 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}

.oh-empty-quota {
  background: #111;
  color: #ffcc00;
  border-radius: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: 900;
  padding: 14px 12px;
  margin-bottom: 16px;
}

.oh-empty-amount {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d8d8d8;
  border-radius: 10px;
  padding: 14px 12px;
  text-align: center;
  font-size: 22px;
  font-weight: 900;
  color: #111;
  background: #fff;
}

.oh-modal-foot {
  padding: 10px 18px 18px;
}

.oh-modal-foot--row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.oh-modal-btn {
  height: 44px;
  border: 0;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
  width: 100%;
}

.oh-modal-btn--yellow {
  background: #ffcc00;
  color: #111;
}

.oh-modal-btn--gray {
  background: #e8e8e8;
  color: #222;
}

.oh-toast {
  position: fixed;
  left: 50%;
  bottom: 80px;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.78);
  color: #fff;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  z-index: 1100;
  max-width: 80vw;
}
</style>
